import { motion } from "framer-motion";
import React from "react";

const ModalWrapper = ({
  isOpen,
  onClose,
  children,
  boxClassName = "",
  backdropClassName = "",
}) => {
  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center bg-black bg-opacity-10 backdrop-blur-sm z-[1200] ${backdropClassName}`}
      onClick={onClose}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        className={`bg-ui-surface p-6 rounded-lg w-96 border border-ui-border m-2 ${boxClassName}`}
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside modal
      >
        {children}
      </motion.div>
    </div>
  );
};

export default ModalWrapper;
